import { autocompleteClasses } from '@mui/material/Autocomplete';

export const autocompleteDropdownOptionsFilterStyles = {
	dropdown: {
		mt: '8px',
		p: 0,
		width: '100%',
		maxHeight: 250,
		listStyle: 'none',
		position: 'absolute',
		zIndex: 1,
		overflow: 'auto',
		borderRadius: 1,
		backgroundColor: 'background.paper',
		boxShadow: '0px 4px 6px 1px rgb(0 0 0 / 0.15)',

		"& li[aria-selected='true']": {
			bgcolor: 'var(--mui-palette-grey-50)',
			fontWeight: 700
		},

		[`& li.${autocompleteClasses.focused}`]: {
			bgcolor: 'var(--mui-palette-primary-lighter)'
		}
	},

	linearProgress: {
		position: 'absolute',
		top: 0,
		left: 0,
		height: 2,
		width: '100%',
		zIndex: 2
	}
};
